import PropTypes from 'prop-types';
import React from 'react';
import { IMAGE_CDN_URL } from '../../../../utilities/imageCDN';
import './CompanyBannerImage.scss';

const transforms = {
    mobile: { width: 576 },
    tablet: { width: 768 },
    desktop: { width: 1110, height: 257 },
};

export default class CompanyBannerImage extends React.PureComponent {
    static propTypes = {
        /**
         * Image Info
         * */
        img: PropTypes.shape({
            /**
             * Image Src
             * */
            src: PropTypes.string.isRequired,
            /**
             * Image alt
             * */
            alt: PropTypes.string,
        }).isRequired,
    };
    static defaultProps = {
        img: {
            src: '',
            alt: '',
        },
    };
    buildSrc = (size) => {
        let transformArr = [];
        if (transforms[size]['width']) {
            transformArr.push(`w_${transforms[size]['width']}`);
        }
        if (transforms[size]['height']) {
            transformArr.push(`h_${transforms[size]['height']}`);
        }
        const transformStr = transformArr.join(',');
        return `${IMAGE_CDN_URL}/c_scale,${transformStr}/dpr_2.0${this.props.img.src}`;
    };

    render() {
        return (
            <div className="component-Layout-CompanyHeaderV2-CompanyBannerImage p-0">
                <div className="d-block d-md-none">
                    <img
                        className="bannerImg"
                        src={`${this.buildSrc('mobile')}`}
                        alt={this.props.img.alt}
                        aria-hidden={true}
                    />
                </div>
                <div className="d-none d-md-block d-lg-none">
                    <img
                        className="bannerImg"
                        src={`${this.buildSrc('tablet')}`}
                        alt={this.props.img.alt}
                        aria-hidden={true}
                    />
                </div>
                <div
                    className="d-none d-lg-block banner-desktop"
                    style={{
                        maxWidth: `${transforms.desktop.width}px`,
                        maxHeight: `${transforms.desktop.height}px`,
                    }}
                >
                    <img
                        className="bannerImg"
                        src={`${this.buildSrc('desktop')}`}
                        alt={this.props.img.alt}
                        aria-hidden={true}
                    />
                </div>
                {/*<div 
                  style={{backgroundImage:`url(${this.buildSrc('mobile')})`}} alt={this.props.img.alt} aria-hidden={true} 
                  className="mobileImg container-fluid p-0 d-lg-none">
                </div>*/}
            </div>
        );
    }
}
